export const EXCEPTION_SCHEDULE = {
  [new Date(2023, 5, 26).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 5, 27).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 5, 28).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 5, 29).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 5, 30).toISOString()]: { start: 9, end: 13 },
  // [new Date(2023, 6, 3).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 6, 4).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 5).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 6).toISOString()]: { start: 9, end: 13 },
  // [new Date(2023, 6, 7).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 10).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 11).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 12).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 6, 13).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 6, 14).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 6, 17).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 6, 18).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 19).toISOString()]: { start: 9, end: 16 },
  // [new Date(2023, 6, 20).toISOString()]: { start: 0, end: 0 },
  // [new Date(2023, 6, 21).toISOString()]: { start: 9, end: 13 },
};
